import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const EmbeddedSystemsModules = () => {
  const modules = ['Module 1', 'Module 2', 'Module 4', 'Module 5'];

  const subtopicsData = {
    'Module 1': [
      { name: 'Overview of Embedded Systems, Design challenges, Embedded processor technology, Hardware Design', path: '/es-m1-s1' },
      { name: 'Micro-controller architecture -8051, PIC, and ARM', path: '/es-m1-s2' }
    ],
    'Module 2': [
      { name: 'ADC DAC', path: '/es-m2-s1' },
      { name: 'Timers & Counters, watchdog Timer, UART, Encoders/decoders', path: '/es-m2-s2' },
      { name: 'Sensors and actuators interfacing', path: '/es-m2-s3' }
    ],
    'Module 4': [
      { name: 'Evolution of Embedded Programming Tools, Modelling Programs, Code Optimization, Logic Analyzers, Programming Environment', path: '/es-m4-s1' }
    ],
    'Module 5': [
      { name: 'Classification of Real Time Systems, Issues & Challenges in RTS', path: '/es-m5-s1' },
      { name: 'Real Time Scheduling Schemes - EDF, RMS & Hybrid Techniques', path: '/es-m5-s2' }
    ]
  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Embedded Systems</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-ESModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmbeddedSystemsModules;
